<template>
  <div class="liste wpts" @mousemove="checkWptpHover" @mouseleave="coverageState.hoverWptKey = ''">
        <div class="line-item" :id="wpt.id" :class="{hover:coverageState.hoverWptKey==`${areaId}_${wpt.id}`}" v-for="wpt in wptList" :key="wpt.id" @dblclick="editWaypoint(wpt)" @keyup.enter="updateWaypoint()">
            <div class="heading ml-2" style="display:flex;"  >                      
              <template v-if="coverageState.currentEditWpt && coverageState.currentEditWpt.id == wpt.id && coverageState.editAreaId == areaId">
                <div style="flex:1 0">
                  <v-text-field autofocus ref="label" :label="$t('Admin.MissionPlanTemplate.Form.Label')" v-model="coverageState.currentEditWpt.wpt_label"></v-text-field>                          
                  <v-layout row>
                    <lat-lng-field :format="coordFormatFilter" :label="$t('Admin.MissionPlanTemplate.Form.Lat')" v-model.number="coverageState.currentEditWpt.wpt_lat" :isLat="true" class="mr-4" />        
                    <lat-lng-field :format="coordFormatFilter" :label="$t('Admin.MissionPlanTemplate.Form.Lng')" v-model.number="coverageState.currentEditWpt.wpt_lon" :isLat="false" class="ml-4" />  
                  </v-layout>  
                </div>       
                <div style="flex:0 0">
                  <v-btn icon small @click="cancelWaypoint()" :title="$t('Admin.MissionPlanTemplate.Form.CancelTooltip')"><v-icon>mdi-close-circle</v-icon></v-btn><br/>   
                  <v-btn icon small @click="updateWaypoint()" :title="$t('Admin.MissionPlanTemplate.Form.ValidTooltip')"><v-icon>mdi-check-circle</v-icon></v-btn>                            
                </div>                        
              </template>
              <template v-else>                
                {{formatWaypoint(wpt)}}
                <v-spacer/>
                <v-btn class="ma-0" icon small @click="editWaypoint(wpt)" :title="$t('Admin.MissionPlanTemplate.Form.Edit')"><v-icon>mdi-pencil</v-icon></v-btn>                      
                <v-btn class="my-0" icon small @click="deleteWaypoint(wpt)"><v-icon>mdi-delete</v-icon></v-btn>
              </template>                                                                    
            </div>
        </div>
        <div v-if="wptList.length == 0">{{$t('Simulation.NoPts')}}</div>
    </div>  
</template>
<script lang="ts">      
  import { gliderWaitingModesColor, GLIDER_MODE } from '@/models/alo/AloMission'      
  import { IMissionPlanWaypoint } from '@/models/iris/missionPlan/IMissionPlanWaypoint'
  import { CoverageUiState } from '@/models/ui/CoverageUiState'
  import { MissionPlanUiState } from '@/models/ui/MissionPlanUiState'
  import { toNumberDictionary } from '@/utils/groupBy'
  import Vue from 'vue'  
  import Component from 'vue-class-component'  

  @Component({
    name: 'SmartCoverageWptList', 
    props:{      
      areaId: Number,
      wptList: Array,
      coverageState: Object      
    }
  })
  export default class SmartCoverageWptList extends Vue {  
    
    areaId!:number
    coverageState!:CoverageUiState
    wptList!:IMissionPlanWaypoint[]
    
    updateWaypoint () {    
      if(!this.coverageState.currentEditWpt.id) return
      const wpt = this.wptsById[this.coverageState.currentEditWpt.id]    
      if(wpt) {
        Object.keys(this.coverageState.currentEditWpt).forEach(key => {
          //@ts-ignore    
          if(key == "wpt_lat" || key == "wpt_lon")   wpt[key] = parseFloat(this.coverageState.currentEditWpt[key])
          //@ts-ignore
          else if(key != 'id') wpt[key] = this.coverageState.currentEditWpt[key]      
        })                    
      }    
      this.cancelWaypoint()
    }

    cancelWaypoint() {
      this.coverageState.currentEditWpt = MissionPlanUiState.getDefaultWayPoint()
      this.coverageState.hoverWptKey = ""
    }  

    formatWaypoint(wpt:IMissionPlanWaypoint) {    
      return wpt.wpt_label&&wpt.wpt_label.length>0?wpt.wpt_label:this.toCoordString(wpt)
    }

    editWaypoint(wpt:IMissionPlanWaypoint) {   
      this.$store.myActions.UI_SET_MEASURETOOL('NONE')
      if(this.coverageState.drawMode != '')  this.coverageState.drawMode = ''
      this.$nextTick(()=>{
        //on memorise les infos si un ancien waypoint etait en edition
        this.updateWaypoint()
        //on edite le nouveau waypoint
        this.coverageState.currentEditWpt =  JSON.parse(JSON.stringify(wpt))           
      })    
    }

    deleteWaypoint(wpt:IMissionPlanWaypoint) {
      this.$confirm(this.$t('Admin.MissionPlanTemplate.Form.ConfirmDeleteWaypointMessage').toString()).then(remove =>{      
        if(remove) {        
          //supprime le waypoint
          this.wptList.splice(this.wptList.findIndex(it => it.id == wpt.id),1)                  
        }
      })    
    }

    checkWptpHover(event:any) {    
      if (!event.target) return
      const item = event.target.closest('.line-item')      
      if (item) this.coverageState.hoverWptKey = `${this.areaId}_${item.id}`      	
      else this.coverageState.hoverWptKey = ""               
    }

    toCoordString(wpt:IMissionPlanWaypoint){
      //@ts-ignore    
      return this.$options.filters[this.$store.myGetters.coordFormatFilter]([wpt.wpt_lon,wpt.wpt_lat])
    }

    get coordFormatFilter(){
      return this.$store.myGetters.coordFormatFilter 
    }

    get wptsById(){
      return toNumberDictionary(this.wptList ?? [],it => it.id)
    }
 
  }
</script>
